import React, { useState } from 'react';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice'; // Import nextTask action
import { Button, Typography, Grid } from '@mui/material';
import {PageContainer} from "../../survey-tools/ui-components/containers"

function RecallIntro({ dispatch }) {
    const [page, setPage] = useState(1);

    const handleNextClick = () => {
        if (page === 1) {
            setPage(2); // Move to the second page
        } else {
            // Dispatch the nextTask action to move to the next task
            dispatch(nextTask({ data: {} })); // You can pass any required data here
        }
    };

    return ( <PageContainer>
            <Grid item xs={11} sm={9} md={7} lg={5}>
                {page === 1 && (
                    <div>
                        <Typography gutterBottom>
                            Great! Now that your audio recording is working, we can move on to the rest of the study.
                        </Typography>
                        <Button
                            onClick={handleNextClick}
                            variant="contained"
                            color="primary"
                            style={{ marginTop: '2em' }}
                        >
                            Next
                        </Button>
                    </div>
                )}
                {page === 2 && (
                    <div>
                        <Typography gutterBottom>
                            On the next page, you will be asked to remember an experience in your life and write about it. Please try to immerse yourself in the memory and to feel the emotions you felt at the time. Your response must be at least 100 words long and as detailed as possible.
                        </Typography>
                    <br />
                        <Typography gutterBottom>
                            After you recall this experience, you will be asked to answer some questions about your emotions and mental states. You are free to skip any questions that cause you discomfort.
                        </Typography>
                        <Button
                            onClick={handleNextClick}
                            variant="contained"
                            color="primary"
                            style={{ marginTop: '2em' }}
                        >
                            Next
                        </Button>
                    </div>
                )}
            </Grid>
        </PageContainer>
    );
}

export default connect()(RecallIntro);
